import { Component, inject } from '@angular/core';
import { MyOffersService } from './services/my-offers.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { OccEndpointsService } from '@spartacus/core';
import { combineLatest, tap } from 'rxjs';
import { DataLayerService } from '../shared/services/data-layer.service';
import { Offer } from './models/offers.model'; // make sure this import path is correct

@Component({
    selector: 'app-my-offers',
    templateUrl: './my-offers.component.html',
    styleUrl: './my-offers.component.scss',
    standalone: false
})
export class MyOffersComponent {
  private readonly myOffersService = inject(MyOffersService);
  private readonly occEndpointService = inject(OccEndpointsService);
  private readonly dataLayerService = inject(DataLayerService);

  readonly baseurl = this.occEndpointService.getBaseUrl({
    baseUrl: true,
    prefix: false,
    baseSite: false,
  });

  // Counters (useful for analytics or other UI; no dividers in template)
  pendingCount = 0;
  acceptedCount = 0;

  scrollToOffer(index: number) {
    const el = document.getElementById(`offer-${index}`);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  onOfferAccepted(updatedOffer: Offer) {
    const offers = this.vm().offerList.offers;
    const idx = offers.findIndex(o => o.offerId === updatedOffer.offerId);
    if (idx > -1) {
      offers[idx] = { ...updatedOffer };
    }

    // Do NOT re-sort — keep the position fixed
    // offers.sort((a, b) => Number(!!a.confirmedDate) - Number(!!b.confirmedDate));

    // Just refresh counts
    this.pendingCount = offers.filter(o => !o.confirmedDate).length;
    this.acceptedCount = offers.length - this.pendingCount;
  }

  private readonly vm$ = combineLatest({
    offerList: this.myOffersService.fetchFreshOffers(),
    user: this.myOffersService.user$,
    selectedLocation: this.myOffersService.getSelectedLocationWhenReady(),
  }).pipe(
    tap(({ offerList }) => {
      if (!offerList.offers || offerList.offers.length === 0) {
        // Fire DL event when no offers
        this.dataLayerService.addtoDataLayer(
          'offerForm_FormEvent',
          {
            error_type:
              'Unfortunately, this offer is unavailable for your selected location. Please select a different location to check for eligibility.',
          },
          null,
          null,
          'form_error'
        );

        this.pendingCount = 0;
        this.acceptedCount = 0;
      } else {
        // One-time initial sort: New (no confirmedDate) first, then Accepted
        offerList.offers.sort(
          (a: Offer, b: Offer) => Number(!!a.confirmedDate) - Number(!!b.confirmedDate)
        );

        // Update counts
        this.pendingCount = offerList.offers.filter(o => !o.confirmedDate).length;
        this.acceptedCount = offerList.offers.length - this.pendingCount;
      }
    })
  );

  readonly vm = toSignal(this.vm$);

  constructor() {}
}
